import { IntegrationsPageHeader } from "@/pages/integrations/integrations-page-header";
import { StyledPageWrapper } from "@/pages/integrations/shared/integrations.styles";
import { IntegrationsCalendarPageContent } from "@/pages/integrations/calendar/integrations-calendar-page-content";
import { observer } from "mobx-react-lite";
import { FC, useEffect, useState } from "react";
import { useTimeout } from "usehooks-ts";
import { useAppStore } from "@/store";

type TProps = {};

export const IntegrationsCalendarPage: FC<TProps> = observer(() => {
  const { store } = useAppStore();
  const [visible, setVisible] = useState(false);
  const isCalendarIntegrationEnabled =
    store.spaceAccountFeatureFlags.getFlagStatus("calendar-integration");

  useTimeout(() => {
    setVisible(true);
  }, 100);

  useEffect(() => {
    if (!isCalendarIntegrationEnabled) store.navigation.goToIntegrations();
  }, [isCalendarIntegrationEnabled, store.navigation]);

  return (
    <StyledPageWrapper visible={visible}>
      <IntegrationsPageHeader />
      <IntegrationsCalendarPageContent />
    </StyledPageWrapper>
  );
});
